import React from 'react';

import ActivityFeed from '@/features/ActivityFeed';
import AnnouncementCarousel from '@/features/AnnouncementCarousel';

import { useCommunityPortalContext } from '@/contexts/CommunityPortalContext';

import GradientBlurToBottomBg from '@/components/common/GradientBlurToBottomBg';

import HomeTopBar from './sections/HomeTopBar';
import SummaryCardSection from './sections/SummaryCardSection';

function HomeTabContent() {
  const { activeCommunity, handleConnectWhatsappBtnClick } =
    useCommunityPortalContext();

  const activeCommunityLink = activeCommunity?.link;
  const activeCommunityBannerImg =
    activeCommunity?.fullScreenBannerImgData?.desktopImgProps?.src;

  return (
    <>
      <GradientBlurToBottomBg bannerImg={activeCommunityBannerImg} />
      <div className="lg:w-[960px] max-w-[980px] md:mx-auto">
        <div className="mx-20">
          <HomeTopBar activeCommunityLink={activeCommunityLink} />
        </div>
        <div className="mx-20">
          <SummaryCardSection
            activeCommunity={activeCommunity}
            handleConnectWhatsappBtnClick={handleConnectWhatsappBtnClick}
          />
        </div>
        <AnnouncementCarousel activeCommunityId={activeCommunity?._id} />
        <div className="mx-20">
          <ActivityFeed
            activeCommunityId={activeCommunity?._id}
            activeCommunity={activeCommunity}
          />
        </div>
      </div>
    </>
  );
}

export default HomeTabContent;
